const filters = (state = [], action) => {

	switch (action.type) {

		case 'SET_FILTER': {

			const { name, value } = action.options;

			return {
				...state,
				[name]: value,
			};
		}

		case 'CLEAR_FILTERS': {

			const filters = {
				distance: 0,
				difficulty: 0,
				type: 0,
				searchName: null
			};

			return { ...filters };
		}

		default:
			return state;
	}
}
export default filters;



// WEBPACK FOOTER //
// ./src/reducers/filters.js